const setAccessibility = () => {
  const resizeBtn = document.querySelectorAll('.js-resize-trigger');
  const searchBtn = document.querySelectorAll('.js-search-trigger');
  if (!resizeBtn.length && !searchBtn.length) return false;

  const setResizeControl = (btn) => {
    const size = btn.dataset.size,
      html = document.documentElement;

    localStorage.setItem('fsize', size);
    btn.disabled = true;
    btn.classList.add('is-active');

    if (size === 'large') {
      html.style.fontSize = '68.75%';
    } else if (size === 'small') {
      html.style.fontSize = '62.5%';
    }
  }

  resizeBtn.forEach(el => {
    const parent = el.closest('.usernav-list'),
      controller = parent.querySelector('.resize-control'),
      controllerBtn = parent.querySelectorAll('.js-resize-btn'),
      form = parent.querySelector('.search-form');

    el.addEventListener('click', () => {
      controller.classList.toggle('is-active');
      form.classList.remove('is-active');
    })

    controllerBtn.forEach(el => {
      el.addEventListener('click', () => {
        [...controllerBtn].map(el => {
          el.disabled = false;
          el.classList.remove('is-active');
        });
        setResizeControl(el);
      })
    })

    const fsize = localStorage.getItem('fsize');
    if (fsize) {
      const btn = document.querySelectorAll(`button[data-size=${fsize}]`);
      btn.forEach(el => {
        [...controllerBtn].map(el => {
          el.disabled = false;
          el.classList.remove('is-active');
        });
        setResizeControl(el);
      })
    }
  })


  searchBtn.forEach(el => {
    const parent = el.closest('.usernav-list'),
      form = parent.querySelector('.search-form'),
      controller = parent.querySelector('.resize-control');

    el.addEventListener('click', () => {
      form.classList.toggle('is-active');
      controller.classList.remove('is-active');
    })
  })
}

export default setAccessibility;